import { cryptoHelper } from '@sc/shared-ui';
import cookie from 'js-cookie';

const NONCE_COOKIE = 'sc-magic-nonce';

// Binds a requested magic link to the browser that requested it: the nonce is
// HMAC'd into the token hash server-side, so a link opened elsewhere (e.g. a
// forwarded email or a scanner prefetch) fails verification without it.
//
// The binding is best-effort: if the browser refuses the cookie (blocked
// cookies, some in-app webviews) we'd issue a link that can never be redeemed,
// so in that case no nonce is sent and the link falls back to plain single-use.
export const useMagicLinkNonce = () => ({
  issueNonce: async (): Promise<string | undefined> => {
    const nonce = await cryptoHelper.generateNonce();

    cookie.set(NONCE_COOKIE, nonce, {
      expires: 1 / 144, // 10 minutes
      sameSite: 'strict',
      path: '/',
    });

    return cookie.get(NONCE_COOKIE) === nonce ? nonce : undefined;
  },
  consumeNonce: (): string | undefined => {
    const nonce = cookie.get(NONCE_COOKIE);

    cookie.remove(NONCE_COOKIE, { path: '/' });

    return nonce;
  },
});
